import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";
import "firebase/auth";

const FirebaseConfig=
{
  apiKey: "AIzaSyDVTOQFoT-yuGiOJE964wrMxsccDKlXhxs",
  authDomain: "cartabaum.firebaseapp.com",
  databaseURL: "https://cartabaum.firebaseio.com",
  projectId: "cartabaum",
  storageBucket: "cartabaum.appspot.com",
  messagingSenderId: "382167524148",
  appId: "1:382167524148:web:63b2ad5de6e7e732327b61",
  measurementId: "G-PZS3WQJXSB",
  storageBucket:"gs://cartabaum"
}
 
if (!firebase.apps.length) 
{
  firebase.initializeApp(FirebaseConfig);
}else {
  firebase.app(); // if already initialized, use that one
}

const db=firebase.firestore();
const realtimeDB=firebase.database();
const storage=firebase.storage();
const auth=firebase.auth();


export default realtimeDB;
export {storage,db,auth};